module.exports = __webpack_public_path__ + "publisher/media/mydigital_logo.c2448d77.svg";